<template>
<div class="votingpage">
    <section class="poll-wrapper">
        <div class="choices-wrapper">
            <div v-for="(token, index) in tokens" :key="index" :class="['poll-item', 'ch' + (index + 1), {'is--winner': winnerIndex === index}]">
                <div class="blob-amount" :style="{ transform: `scale(1, ${normalizedResults[index]})` }">
                    <div class="wave wave--back">
                        <div class="water">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
                                <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
                            </svg>
                        </div>
                        <div class="water">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
                                <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
                            </svg>
                        </div>
                    </div>
                    <div class="wave wave--front">
                        <div class="water">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
                                <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
                            </svg>
                        </div>
                        <div class="water">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
                                <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="item-details">
                    <h3></h3>
                    <h1>{{ token.symbol }}</h1>
                    <img :src="require(`@/assets/img/ranking/${token.symbol}-logo.png`)" style="height: 64px; margin: 5% auto;"/>
                    <h3>{{ token.totalVotes }} {{ $t('lang.votes') }}</h3>
                    <div v-if="true || user && !user.votedFor" class="btn vote" @click="selectVote(token.symbol)">{{ $t('lang.Vote') }}</div>
                </div>
                <button class="btn expand-btn" @click="scrollToSection(index)">{{ $t('lang.expand') }}</button>
            </div>
        </div>
    </section>


    <Leaderboard id="leaderboard" :tokens="tokensSorted" :votes="user ? user.votes : []"/>


    <detail :id="`section-${index}`" v-for="(token, index) in tokens" :key="index" :token="token" :_key="index" :style="`background-color: ${['#EB5439','#01A1A1','#2E3DD8','#737486'][index]};`"/>

    <section class="text-container">
        <div class="text-block">
            <h5>{{ $t('lang.ruleTitle') }}</h5>
            <p>{{ $t('lang.ruleParagraph') }}</p>
        </div>
    </section>


    <div id="modalExit" class="modal-exit">
        <div class="modal-exit-content">
            <div id="modal-exit-title" class="modal-exit-title">
            {{ $t('lang.Vote') }} {{ this.symbol }} ?
            </div>
            <div id="modal-exit-desc" class="modal-exit-desc">
            </div>
        </div>
        <div class="modal-exit-button" v-on:click="closeModal">
          {{ $t('lang.Cancel') }}
        </div>
        <div id="modalConfirm" class="modal-exit-button" v-on:click="vote">
            {{ user ? user.votedFor ? 'Close' : 'Vote' : 'Close' }}
        </div>
    </div>



</div>
</template>

<script>
import request from "@/services/request";
import detail from "./detail.vue";
import Leaderboard from "./leaderboard.vue";
export default {
    components: {
        detail,
        Leaderboard
    },
    data() {
        return {
            user: null,
            tokens: [
                {
                    "name": "GSC公链",
                    "symbol": "GSC",
                    "totalVotes": 0,
                },
                {
                    "name": "OORT公链",
                    "symbol": "OORT",
                    "totalVotes": 0,
                },
                {
                    "name": "CFX公链",
                    "symbol": "CFX",
                    "totalVotes": 0,
                },
                {
                    "name": "BTY公链",
                    "symbol": "BTY",
                    "totalVotes": 0,
                }
            ],
            tokensSorted: [],
            lang: "",
            symbol: "",
            winnerIndex: null,
            detailsOpen: false,
            votedIndex: null,
        }
    },
    created() {
        this.lang = sessionStorage.getItem("Language");
        this.getUser();
        this.getTokens();
    },
    computed: {
        totalVotes() {
            return this.tokens.map(token => token.totalVotes);
        },
        normalizedResults() {
            const maxVotes = Math.max(...this.totalVotes);
            return this.totalVotes.map(vote => maxVotes > 0 ? (vote / maxVotes * 0.7 + 0.2) : 0.2);
        }
    },
    methods: {
        getUser() {
          request.getVotingUser().then((res) => {
            console.log(res)
            this.user = res;
          }).catch(error => {
              console.log(error);
              this.register();
          });
        },
        register() {
            request.register().then((res) => {
                this.user = res;
            }).catch(error => {
                console.log(error);
            });
        },
        getTokens() {
            request.rankingBoard().then((res) => {
                this.tokensSorted = res;
                res.forEach(token => {
                    this.tokens.filter(_token => _token.symbol == token.symbol)[0].totalVotes = token.totalVotes;
                })
            });
        },
        selectVote(symbol) {
            this.symbol = symbol;
            this.displayModal();
        },
        vote() {
          if (!this.user || this.user.votedFor) return this.closeModal();
          let parma = {
              symbol: this.symbol
          };
          request.vote(parma).then((res)=> {
              this.user = res
              this.getTokens();
              this.getUser();
              this.closeModal();
              document.getElementById(`leaderboard`)?.scrollIntoView({ behavior: 'smooth', block: 'end' });
          })
        },
        handleClick(symbol){
            const links = {
                GSC:'https://www.gsc.social/',
                OORT:'https://www.oortech.com/',
                CFX:'https://confluxnetwork.org/',
                BTY:'https://bityuan.com/'}
            if(links[symbol]){
                window.open(links[symbol]);
            }
        },
        showResults() {
            this.results = this.contestants.map(value => parseInt(value));
            this.winnerIndex = this.results.indexOf(Math.max(...this.results));
            document.querySelectorAll('.vote').forEach(el => el.classList.add('results-r-in'));
        },
        scrollToSection(index) {
            document.getElementById(`section-${index}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        displayModal() {
            console.log(this.$t.vote)
            document.getElementById('modal-exit-title').innerText = this.user && !this.user.votedFor ? `${this.$t('lang.Vote')} ${ this.symbol } ?` : this.$t('lang.prohibited');
            document.getElementById('modalConfirm').innerText = this.user && !this.user.votedFor ? this.$t('lang.Vote') : this.$t('lang.Close');
            document.getElementById('modal-exit-desc').innerText = !this.user ? this.$t('lang.mint1Nft') : this.user.votedFor ? `${this.$t('lang.voted')} ${this.user.votedFor}` : `${this.$t('lang.confirmVote')} ${this.symbol}`;
            document.getElementById('modalExit').style.visibility = "visible";
        },
        closeModal() {
            document.getElementById('modalExit').style.visibility = "hidden";
            this.symbol = "";
        }
    }
}
</script>



<style lang='less' scoped>
.votingpage {
  scroll-behavior: smooth;
}
html,
body {
  width: 100%;
  height: 100%;
}

section {
  width: 100%;
  height: 100%;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

#ltmWrapper {
  width: 100%;
  height: 100%;
}

[class*=ltm-] {
  fill: #fff;
}

nav {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  z-index: 5;
  font-family: "Roboto", sans-serif;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  padding: 10px;
}
nav .nav-logo {
  width: 200px;
  height: 40px;
}
nav .nav-logo:hover svg {
  fill: #333;
}
nav .nav-logo svg {
  overflow: visible;
  width: 100%;
  height: 100%;
}
nav .nav-logo svg * {
  width: 100%;
  height: 100%;
}

.choices-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}
.choices-wrapper .poll-item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50vh;
  text-align: center;
  padding: 15px;
  color: #fff;
  overflow: hidden;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) all;
  flex: 1;
}
.choices-wrapper .poll-item:hover {
  flex: 2;
}
.choices-wrapper .poll-item:hover button {
  transform: translatex(-50%) translatey(0%);
  opacity: 1;
}
.choices-wrapper .poll-item.is--winner:after {
  display: block;
  -webkit-animation: fadeout 1100ms cubic-bezier(0.4, 0, 0.2, 1) forwards 1000ms;
          animation: fadeout 1100ms cubic-bezier(0.4, 0, 0.2, 1) forwards 1000ms;
}
.choices-wrapper .poll-item:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: soft-light;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 0;
}
.choices-wrapper .poll-item:after {
  display: none;
  content: "";
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0;
  transition: 450ms cubic-bezier(0.4, 0, 0.2, 1) all;
  z-index: 2;
}
.choices-wrapper .poll-item .blob-amount {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transform: scale(1, 0);
  transform-origin: bottom center;
  transition: 1000ms cubic-bezier(0.4, 0, 0.2, 1) transform;
}
.choices-wrapper .poll-item .blob-amount .wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.2;
  -webkit-animation: wave 1300ms linear infinite;
          animation: wave 1300ms linear infinite;
}
.choices-wrapper .poll-item .blob-amount .wave--front {
  z-index: 2;
  color: #000;
}
.choices-wrapper .poll-item .blob-amount .wave--front .water svg {
  fill: #000;
}
.choices-wrapper .poll-item .blob-amount .wave--back {
  z-index: 1;
  color: black;
  animation-direction: reverse;
  -webkit-animation-duration: 1100ms;
          animation-duration: 1100ms;
}
.choices-wrapper .poll-item .blob-amount .wave--back .water svg {
  fill: black;
}
.choices-wrapper .poll-item .blob-amount .water {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: currentcolor;
}
.choices-wrapper .poll-item .blob-amount .water svg {
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 99.9%;
}
.choices-wrapper .poll-item .blob-amount .water:first-of-type {
  transform: translate(-100%, 0);
}
.choices-wrapper .poll-item.ch1 {
  background-color: #EB5439;
}
.choices-wrapper .poll-item.ch1:before {
  //background-image: url(../image/601.jpg);
}
.choices-wrapper .poll-item.ch1 .vote {
  color: #EB5439;
  box-shadow: 0 2px 4px rgba(173, 41, 17, 0.6);
}
.choices-wrapper .poll-item.ch1 .vote:hover {
  box-shadow: 0 10px 20px rgba(173, 41, 17, 0.6);
}
.choices-wrapper .poll-item.ch1 .expand-btn:hover {
  color: #EB5439;
}
.choices-wrapper .poll-item.ch2 {
  background-color: #01A1A1;
}
.choices-wrapper .poll-item.ch2:before {
  //background-image: url(../image/603.jpg);
}
.choices-wrapper .poll-item.ch2 .vote {
  color: #01A1A1;
  box-shadow: 0 2px 4px rgba(0, 60, 60, 0.6);
}
.choices-wrapper .poll-item.ch2 .vote:hover {
  box-shadow: 0 10px 20px rgba(0, 60, 60, 0.6);
}
.choices-wrapper .poll-item.ch2 .expand-btn:hover {
  color: #01A1A1;
}
.choices-wrapper .poll-item.ch3 {
  background-color: #2E3DD8;
}
.choices-wrapper .poll-item.ch3:before {
  //background-image: url(../image/602.jpg);
}
.choices-wrapper .poll-item.ch3 .vote {
  color: #2E3DD8;
  box-shadow: 0 2px 4px rgba(25, 35, 135, 0.6);
}
.choices-wrapper .poll-item.ch3 .vote:hover {
  box-shadow: 0 10px 20px rgba(25, 35, 135, 0.6);
}
.choices-wrapper .poll-item.ch3 .expand-btn:hover {
  color: #2E3DD8;
}
.choices-wrapper .poll-item.ch4 {
  background-color: #737486;
}
.choices-wrapper .poll-item.ch4:before {
  //background-image: url(../image/604.jpg);
}
.choices-wrapper .poll-item.ch4 .vote {
  color: #737486;
  box-shadow: 0 2px 4px rgba(68, 68, 79, 0.6);
}
.choices-wrapper .poll-item.ch4 .vote:hover {
  box-shadow: 0 10px 20px rgba(68, 68, 79, 0.6);
}
.choices-wrapper .poll-item.ch4 .expand-btn:hover {
  color: #737486;
}
.choices-wrapper .poll-item.ch5 {
  background-color: #69C033;
}
.choices-wrapper .poll-item.ch5:before {
  //background-image: url(../image/605.jpg);
}
.choices-wrapper .poll-item.ch5 .vote {
  color: #69C033;
  box-shadow: 0 2px 4px rgba(61, 111, 30, 0.6);
}
.choices-wrapper .poll-item.ch5 .vote:hover {
  box-shadow: 0 10px 20px rgba(61, 111, 30, 0.6);
}
.choices-wrapper .poll-item.ch5 .expand-btn:hover {
  color: #69C033;
}
.choices-wrapper .poll-item .item-details {
  position: relative;
  max-width: 300px;
  width: 100%;
  margin: 0 auto;
  z-index: 2;
}
.choices-wrapper .poll-item .item-details h1,
.choices-wrapper .poll-item .item-details h3 {
  margin: 0;
  white-space: nowrap;
}
.choices-wrapper .poll-item .item-details h1 {
  margin: 0.1em 0;
  text-transform: uppercase;
}
.choices-wrapper .poll-item .item-details h3 {
  font-weight: lighter;
  opacity: 0.54;
}

.poll-details {
  position: relative;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  z-index: 4;
  background-color: #fff;
  padding: 20px;
  padding-top: 75px;
}
.poll-details.open {
  transform: translatey(-100%);
}
.poll-details .close-panel {
  cursor: pointer;
  position: absolute;
  top: 55px;
  left: 50%;
}

.btn {
  -webkit-user-select: none;
  -moz-user-select: none;
   -ms-user-select: none;
       user-select: none;
  cursor: pointer;
  background: #fff;
  border-radius: 25px;
  line-height: 50px;
  height: 50px;
  transition: 335ms cubic-bezier(0.4, 0, 0.2, 1) all;
  outline: none;
  border: none;
  padding: 0 10px;
}
.btn + .btn {
  margin-left: 10px;
}

.vote {
  position: relative;
  margin: 0 auto;
  margin-top: 40px;
  width: 100px;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) transform 420ms, 335ms cubic-bezier(0.4, 0, 0.2, 1) width, 225ms cubic-bezier(0.4, 0, 0.2, 1) color, 335ms cubic-bezier(0.4, 0, 0.2, 1) box-shadow;
}
.vote.results-r-in {
  color: transparent !important;
  width: 30px;
  transform: scale(0);
}
.vote .click-voted {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  -webkit-animation: plusone 555ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation: plusone 555ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.expand-btn {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translatex(-50%) translatey(100%);
  background: none;
  width: 100%;
  max-width: 100px;
  line-height: 27px;
  color: #fff;
  border: 2px solid #fff;
  opacity: 0;
}
.expand-btn:hover {
  background-color: #fff;
}

@-webkit-keyframes wave {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(50%, 0.5em, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes wave {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(50%, 0.5em, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
@-webkit-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-webkit-keyframes plusone {
  to {
    transform: translateY(-50%);
    opacity: 0;
  }
}
@keyframes plusone {
  to {
    transform: translateY(-50%);
    opacity: 0;
  }
}





.modal-exit {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

  background-color: #f2f2f2;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  box-shadow: 0px 0px 72px rgba(0, 0, 0, 0.18);
  box-sizing: border-box;
  color: #484848;
  display: inline-block;
  width: 360px;
  transition: transform 0.14s, opacity 0.14s ease-in-out;
  visibility: hidden;
  z-index: 10;
}

.modal-exit-content {
  padding: 24px;
  height: 140px;
  text-align: center;
}

.modal-exit-title {
 -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
  letter-spacing: 0.1em;
  padding-bottom: 12px;
  text-transform: uppercase;
}

.modal-exit-desc {
 -webkit-font-smoothing: antialiased;
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0.04em;
  line-height: 1.6;
}

.modal-exit-button {
  -webkit-font-smoothing: antialiased;
  border-right: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  float: left;
  font-size: .7em;
  font-weight: 600;
  letter-spacing: .09em;
  padding: 18px;
  text-align: center;
  text-transform: uppercase;
  transition: background-color 0.14s, color 0.14s ease-in-out;
  width: 50%;
}

.modal-exit-button:last-child {
  border-right: none;
}

.modal-exit-button:hover {
  background-color: #fff;
  color: #121212;
}





.text-container {
    position: relative;
    box-sizing: border-box;
    margin: 0;

    padding: 10vh 10vw;
    text-align: center;
    .text-block {
        width: fit-content;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        h5 {
            font-size: 2.5rem;
            margin: 0;
        }
    }
  }
</style>